export default ({ BREAKPOINTS }) => ({
  cell: {
    width: '33.333%',
    padding: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      width: '100%',
      margin: '20px 0 0',
      padding: '0',
      '&:first-child': {
        margin: '0'
      }
    }
  }
})
